import sgllogo from "../images/sgllogo.png";
import printer_icon from "../images/printer.png";
import "./results.css";
import SglContext from '../SglContext'
import { Link } from "react-router-dom";
import { useRef } from "react";

const axios = require("axios").default;

const { useState, useEffect, useContext } = require("react");


function Results(props) {

  const [show_details, setShowDetails] = useState({});
  const [divisions, setDivisions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [shows_list, setShowsList] = useState();
  const [current_show, setCurrentShow] = useState(
    localStorage.getItem("show_id")
  );
  const [loose_class_heading, setLooseClassHeading] = useState("");
  const [div_type, setDivType] = useState("jumper");
  const [class_type, setClassType] = useState("Jumpers");
  const [show_name, setShowName] = useState("");
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState();
  const Sgl = useContext(SglContext);
  const latestRequestRef = useRef(0);

  useEffect(() => {
    getAllData(div_type, props.current_show);
  }, [div_type, props.current_show]);

  const getResultsData = (div_type, show) => {
    const requestId = ++latestRequestRef.current;
    axios
      .get(Sgl.nestApiUrl + "/results", {
        params: {
          div_type: div_type,
          show_id: show,
          customer_id: Sgl.company_id,
        },
      })
      .then((res) => {
        if (requestId === latestRequestRef.current) {
          setDivisions(res.data.divisions);
          setClasses(res.data.classes);
          setCurrentShow(res.data.show_id);
          setLooseClassHeading(res.data.loose_class_heading);
          setDivType(res.data.div_type);
          setClassType(res.data.class_type);
          setShowName(res.data.show_name);
          setLoading(false);
          document.title = "Results for " + show_name;

          Sgl.reportToGA(
            "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
            "/" +
            current_show +
            "/results/list/" +
            div_type
          );
          Sgl.reportToFB(
            "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
            "/" +
            current_show +
            "/results/list/" +
            div_type
          );
        }
      });
  };

  const getAllData = (div_type, show) => {
    getUserData();

    axios
      .all([
        axios.get(Sgl.nestApiUrl + "/results", {
          params: {
            div_type: div_type,
            show_id: show,
            customer_id: Sgl.company_id,
          },
        }),
      ])
      .then(
        axios.spread((schedule) => {
          setDivisions(schedule.data.divisions);
          setClasses(schedule.data.classes);
          setCurrentShow(schedule.data.show_id);
          setLooseClassHeading(schedule.data.loose_class_heading);
          setDivType(schedule.data.div_type);
          setClassType(schedule.data.class_type);
          setShowName(schedule.data.show_name);
          setLoading(false);

          document.title = "Results for " + schedule.data.show_name;
          Sgl.reportToGA(
            "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
            "/" +
            current_show +
            "/results/list/" +
            div_type
          );
          Sgl.reportToFB(
            "/sgl-wp-plugin/" +
            Sgl.company_urlpath +
            "/" +
            current_show +
            "/results/list/" +
            div_type
          );
        })
      );
  };


  const openTab = (tabName) => (e) => {
    var i, tablinks;

    tablinks = document.getElementsByClassName("tablinks");

    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    e.currentTarget.className += " active";

    getResultsData(tabName, props.current_show);
  };

  const format_time = (timeString) => {
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = H < 12 || H === 24 ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  };

  const getDefaultTab = (tab) => {
    if (div_type == tab) {
      return " active";
    }
    return "";
  };
  const getUserData = () => {
    axios.get(Sgl.nestApiUrl + "/users/getUser").then(
      (response) => {
        if (response.data.user && response.data.user != null) {

          setUserData(response.data.user);
        } else {
        }
      },
      (error) => { }
    );
  };


  if (loading) {
    return null;
  }

  return (
    <div id="section-to-print" className="resultscss section-to-print">
        <section className="search-area">
      <h2 className="sgl-h2">Results for {show_name}</h2>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
      <br />
      <div className="section-tab tab no_print">
        <button
          className={["tablinks", getDefaultTab("jumper")].join(" ")}
          onClick={openTab("jumper")}
        >
          Jumper
        </button>
        <button
          className={["tablinks", getDefaultTab("hunter")].join(" ")}
          onClick={openTab("hunter")}
        >
          Hunter
        </button>
        <button
          className={["tablinks", getDefaultTab("equitation")].join(" ")}
          onClick={openTab("equitation")}
        >
          Equitation
        </button>
        <button
          className={["tablinks", getDefaultTab("dressage")].join(" ")}
          onClick={openTab("dressage")}
        >
          Dressage
        </button>
        <a className="result_print" onClick={() => window.print()}>
          <img className="printer-icon" src={printer_icon} />
         {" "}Print
        </a>
      </div>

      {
        classes.length > 0 || divisions.length > 0 ? (
          <div>
            {classes.length > 0 && (
              <div className="div-responsive">
                <table className="table table-hover table-striped">
                  <thead className="classes-header">
                    <tr className="sgl-primary-header">
                      <th colSpan="8">{loose_class_heading}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {classes.map((data, index) => {
                      return (
                        <tr className="sgl-anchor">
                          <td>
                            <Link
                              to={"/classes/detail?cid=" + data.class_id + "&sid=" + current_show}
                            >
                              {data.number} - {data.name}
                              {data.sponsor ? (
                                <span className="sponsor_text">
                                  {" "}
                                  (Sponsored By: {data.sponsor})
                                </span>
                              ) : (
                                ""
                              )}
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {divisions.length > 0 && (
              <div className="div-responsive">
                <table className="table table-hover table-striped">
                  <thead className="classes-header">
                    <tr className="sgl-primary-header">
                      <th colSpan="8">Divisions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {divisions.map((data, index) => {
                      return (
                        <tr className="sgl-anchor">
                          <td>
                            <Link to={"/results/detail?div_id=" + data.division_id + "&sid=" + current_show}>{data.name}</Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : (
          <table>
            <tbody>
              <tr>
                <td>No records found.</td>
              </tr>
            </tbody>
          </table>
        )

      }
      <div id="print_footer" className="print_block print_footer">
        <span>
          <img className="footer_logo" src={sgllogo} />
          Copyright © {(new Date().getFullYear())} · All rights reserved · ShowGrounds, LLC. · Shelburne
          Falls MA · 1-888-429-9495
        </span>
      </div>
      <div className="copyright-text no_print">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
      </section>
    </div>
  );
}

export default Results;
